import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RxAuthService } from '../rx-auth/rx-auth.service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class RetailerProfileService {

  constructor(private http:HttpClient, private auth:RxAuthService) { }

  getProfile(payload:any): Observable<any> {
    let url = environment.backend_base+"main/retailer/get_profile/"
    
  return this.http.post(url, payload)
  }
}
